/**
 * Gemeinsame Theme-Konfiguration für Typografie, Breakpoints und allgemeine Komponenten-Overrides.
 * Wird von lightTheme.ts und darkTheme.ts verwendet, um Duplikate zu vermeiden.
 */

import {ThemeOptions} from '@mui/material/styles';

import {status} from './customColors';

export const sharedTypography: ThemeOptions['typography'] = {
  fontFamily: 'Lato',
  h1: {fontWeight: 'normal', lineHeight: 1, letterSpacing: -0.66},
  h2: {fontWeight: 'normal', lineHeight: 1, letterSpacing: -0.5},
  h3: {
    fontWeight: 300,
    lineHeight: 1.02,
    letterSpacing: 'normal',
    fontSize: 14,
  },
  h4: {fontWeight: 'normal', lineHeight: 1.15, letterSpacing: 0.07},
  h5: {fontWeight: 500, lineHeight: 1.6, letterSpacing: 0.07},
  h6: {fontWeight: 700, lineHeight: 1.6, letterSpacing: 0.07},
  subtitle1: {
    fontWeight: 'normal',
    fontSize: '1rem',
    lineHeight: 1.75,
    letterSpacing: 0.09,
  },
  subtitle2: {
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: 0.07,
  },
  body1: {
    letterSpacing: 0.09,
  },
  body2: {
    letterSpacing: 0.1,
  },
  caption: {
    letterSpacing: 0.3,
    fontWeight: 500,
  },
  button: {
    lineHeight: 1.71,
    '&:disabled': {
      color: status.error.main,
    },
  },
  overline: {
    fontWeight: 500,
    letterSpacing: 0.83,
  },
};

export const sharedBreakpoints: ThemeOptions['breakpoints'] = {
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 2520,
  },
};

export const sharedTypographyOverrides = {
  styleOverrides: {
    root: {
      '&.headline': {
        fontWeight: 500,
        fontSize: 12,
      },
      '&.subline': {
        fontWeight: 300,
        fontSize: 12,
      },
    },
  },
};
